import type {
  UserApiResponse,
  UserDetailApiResponse,
} from '../../features/users/users.models';

/**
 * ユーザー詳細 Mock データ（単一ソース）。
 * 一覧用データ（UserApiResponse）はここから派生させる（getMockUsers）。
 * 更新系ハンドラ（PATCH/DELETE/POST policies/DELETE policies）は、
 * この配列を直接 mutate して状態を反映する。
 */
export const MOCK_USER_DETAILS: UserDetailApiResponse[] = [
  {
    publicId: 'user-001',
    email: 'tanaka.ichiro@example.com',
    name: '田中 一郎',
    role: 'tenantAdmin',
    userType: 'Customer',
    policies: [
      {
        publicId: 'policy-001',
        name: 'テナント管理者ポリシー',
        isTenantAdmin: true,
        permissions: [
          { groupId: '*', groupName: 'すべてのグループ', access: 'writable' },
        ],
      },
    ],
    createdAt: '2024-01-10T09:00:00.000Z',
    updatedAt: '2024-01-10T09:00:00.000Z',
  },
  {
    publicId: 'user-002',
    email: 'sato.hanako@example.com',
    name: '佐藤 花子',
    role: 'member',
    userType: 'Customer',
    policies: [
      {
        publicId: 'policy-002',
        name: '八幡チーム審査担当',
        isTenantAdmin: false,
        permissions: [
          { groupId: 'group-005', groupName: '八幡事業所', access: 'writable' },
        ],
      },
    ],
    createdAt: '2024-02-01T09:00:00.000Z',
    updatedAt: '2024-02-01T09:00:00.000Z',
  },
  {
    publicId: 'user-003',
    email: 'suzuki.taro@example.com',
    name: '鈴木 太郎',
    role: 'member',
    userType: 'Customer',
    policies: [
      {
        publicId: 'policy-002',
        name: '八幡チーム審査担当',
        isTenantAdmin: false,
        permissions: [
          { groupId: 'group-005', groupName: '八幡事業所', access: 'writable' },
        ],
      },
      {
        publicId: 'policy-003',
        name: '東日本閲覧専用',
        isTenantAdmin: false,
        permissions: [
          {
            groupId: 'group-003',
            groupName: '東日本製鉄所',
            access: 'readonly',
          },
        ],
      },
    ],
    createdAt: '2024-02-15T09:00:00.000Z',
    updatedAt: '2024-02-15T09:00:00.000Z',
  },
  {
    publicId: 'user-004',
    email: 'yamamoto.keiko@example.com',
    name: '山本 恵子',
    role: 'member',
    userType: 'Customer',
    policies: [],
    createdAt: '2024-03-01T09:00:00.000Z',
    updatedAt: '2024-03-01T09:00:00.000Z',
  },
  {
    publicId: 'user-005',
    email: 'nakamura.ryo@example.com',
    name: '中村 涼',
    role: 'member',
    userType: 'Customer',
    policies: [
      {
        publicId: 'policy-003',
        name: '東日本閲覧専用',
        isTenantAdmin: false,
        permissions: [
          {
            groupId: 'group-003',
            groupName: '東日本製鉄所',
            access: 'readonly',
          },
        ],
      },
    ],
    createdAt: '2024-03-20T09:00:00.000Z',
    updatedAt: '2024-03-20T09:00:00.000Z',
  },
  {
    publicId: 'user-006',
    email: 'kobayashi.yuki@example.com',
    name: '小林 雪',
    role: 'tenantAdmin',
    userType: 'Customer',
    policies: [
      {
        publicId: 'policy-001',
        name: 'テナント管理者ポリシー',
        isTenantAdmin: true,
        permissions: [
          { groupId: '*', groupName: 'すべてのグループ', access: 'writable' },
        ],
      },
    ],
    createdAt: '2024-04-01T09:00:00.000Z',
    updatedAt: '2024-04-01T09:00:00.000Z',
  },
];

/**
 * 一覧用 Mock データを MOCK_USER_DETAILS から派生させる。
 * UserApiResponse.policies は PolicyRef[]（publicId/name のみ）であるため、
 * permissions 等の詳細を落として変換する。
 */
export function getMockUsers(): UserApiResponse[] {
  return MOCK_USER_DETAILS.map((u) => ({
    publicId: u.publicId,
    email: u.email,
    name: u.name,
    role: u.role,
    userType: u.userType,
    policies: u.policies.map((p) => ({ publicId: p.publicId, name: p.name })),
    createdAt: u.createdAt,
    updatedAt: u.updatedAt,
  }));
}

/**
 * ユーザーIDからユーザー詳細データを取得
 */
export function findUserDetailById(
  userId: string,
): UserDetailApiResponse | undefined {
  return MOCK_USER_DETAILS.find((u) => u.publicId === userId);
}
